import { Model } from '@socrates/common';
import { SearchResponseInfo } from './SearchResponseInfo';

// This interface takes the rest path and the query parameters (in the form of a
// traditional javascript object acting as a map style collection -- attribute are
// names, their values are the key's value), and issues the request.  We are doing
// this in order to decouple our logic classes from $http, in case the need to interface
// with some other type of data source arises.
export abstract class IRestSearch {
	abstract search<T extends Model>(queryPath: string, parameters: any, modelFactory: any): Promise<SearchResponseInfo<T>>;
}
